import { fetchFromAPI } from "./fetch-from-api";
import { GetImpactReportCsvRequestBody } from "@ecologi/shared";

export const getImpactReportCsv = async ({
  apiOnly,
  impactTypes,
  startDate,
  endDate,
  userId,
  accessToken,
}: GetImpactReportCsvRequestBody): Promise<string> => {
  const response = await fetchFromAPI(`/users/${userId}/impact-report.csv`, {
    body: JSON.stringify({
      apiOnly,
      impactTypes,
      startDate,
      endDate,
    }),
    method: "POST",
    passthrough: "api",
    raw: true,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return response.text();
};
